import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import {FeatureGroup, Map, Polygon, TileLayer, ZoomControl} from "react-leaflet";
import {IMapas, IParcela} from "../../../types";
import {LatLngTuple} from "leaflet";


interface IProps {
    zoom: number
    center: LatLngTuple
    parcela: IParcela
    sectores: Record<string, LatLngTuple[]>
    sector: string
    setMapa(mapa: IMapas): void
    setZoom(zoom: number): void
    setCenter(center: LatLngTuple): void
    setSector(sector: string):void
}

interface IState {
    hover: string
}

const urls = {
    satelite: 'https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
    carreteras: 'https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}'
}

class MapaRiego extends React.Component<IProps, IState> {
    state: IState = {
        hover: ''
    }

    render () {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    height: '100%'
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />
                <Map
                    center={this.props.center}
                    zoom={this.props.zoom}
                    maxZoom={20}
                    style={{
                        width: '100%',
                        height: '100%',
                        borderRadius: 20,
                        zIndex: 1
                    }}
                    onmoveend={(e) => {
                        this.props.setZoom(e.target.getZoom())
                        this.props.setCenter([e.target.getCenter().lat,e.target.getCenter().lng])
                    }}
                    zoomControl={false}
                >
                    <ZoomControl
                        position={'topright'}
                    />
                    <TileLayer url={urls.satelite}/>


                    <FeatureGroup>
                        <Polygon
                            key={this.props.parcela.id}
                            positions={this.props.parcela.lat_lon}
                            color={'rgb(255,255,255)'}
                            fillColor={'rgb(255,255,255,0)'}
                        />
                    </FeatureGroup>

                    <FeatureGroup>
                        {Object.keys(this.props.sectores).map((id) =>
                            <Polygon
                                key={id}
                                positions={this.props.sectores[id]}
                                color={'rgb(31,102,144)'}
                                fillColor={'rgb(31,102,144)'}
                                onclick={() => this.props.setSector(id)}
                            />
                        )}
                    </FeatureGroup>

                    <FeatureGroup>
                        {Object.keys(this.props.sectores).map((id) =>
                            id === this.props.sector &&
                            <Polygon
                                key={id}
                                positions={this.props.sectores[id]}
                                color={'#80ED99'}
                                fillColor={'#80ED99'}
                                weight={4}
                            />
                        )}
                    </FeatureGroup>


                </Map>

            </div>
        )
    }
}


const mapStateToProps = (state: IStore) => ({
    mapa: state.principal.mapa,
    zoom: state.principal.zoom,
    center: state.principal.center,
    parcela: state.riego.parcela,
    sectores: state.riego.sectores,
    sector: state.riego.sector
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setMapa: (mapa: IMapas) => dispatch({type: "set-principal-mapa", mapa}),
    setZoom: (zoom: number) => dispatch({type: "set-principal-zoom", zoom}),
    setCenter: (center: LatLngTuple) => dispatch({type: "set-principal-center", center}),
    setSector: (sector: string) => dispatch({type: "set-riego-sector", sector})
});

export default connect(mapStateToProps, mapDispatchToProps)(MapaRiego);